/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { ExclusiveProductContent } from '../exclusive-product-content.interface';
import { FileService } from '@shared/data-access/services';
import { pdpJsonFileName } from '@pdp/data-access/constants';

@Component({
	selector: 'pdp-exclusive-product-ad',
	templateUrl: './exclusive-product-ad.component.html',
	styleUrl: './exclusive-product-ad.component.scss',
	standalone: false
})
export class ExclusiveProductAdComponent implements OnInit {
	@Input() brand: string;

	content: ExclusiveProductContent;

	constructor(public fileService: FileService) {}

	ngOnInit() {
		const EXCLUSIVE_CONTENT = this.fileService.getDataFileByType$(
			pdpJsonFileName.exclusiveContent,
			'json'
		);

		EXCLUSIVE_CONTENT.subscribe((values) => {
			this.content = values[this.brand];
		});
	}
}
